import QUADRATIC_POLYNOMIALS from "./Questions/quadratic_polynomials";

export default function POLYNOMIALS() {
  return (
    <section id="polynomials" className="grid gap-16">
      <QUADRATIC_POLYNOMIALS />
    </section>
  );
}
